import { FC } from "react";

import { ManageSectionPagesContent } from "./ManageSectionPagesContent";

import { t } from "i18n/i18n";
import { Button } from "mds/components/Button";

export interface ManageSectionPagesModalProps {
  onClose: () => void;
  onPageClick: (href: string) => void;
}

export const ManageSectionPagesModal: FC<ManageSectionPagesModalProps> = ({
  onClose,
  onPageClick,
}) => (
  <>
    <ManageSectionPagesContent
      className="-mt-3"
      scrollAreaClassName="max-h-[60vh]"
      onPageClick={onPageClick}
    />

    <div className="mt-2 flex justify-end">
      <Button kind="blue" size="s" onClick={onClose}>
        {t("common.done")}
      </Button>
    </div>
  </>
);
